module.exports = __webpack_public_path__ + "media/images/video-player-placeholder-default-a937a941c6ecf5f4ef98b5e6013d2654.png";